// Registers all A2UI component renderers into the component registry.
// Call ensureComponentsRegistered() to guarantee registration has run.

import { registerAllComponents } from './componentRegistry.ts';
import { A2UIModal } from './container/A2UIModal.tsx';
import { A2UITabs } from './container/A2UITabs.tsx';
import { A2UIAudioPlayer } from './display/A2UIAudioPlayer.tsx';
import { A2UIIcon } from './display/A2UIIcon.tsx';
import { A2UIImage } from './display/A2UIImage.tsx';
import { A2UIText } from './display/A2UIText.tsx';
import { A2UIVideo } from './display/A2UIVideo.tsx';
import { A2UIButton } from './input/A2UIButton.tsx';
import { A2UICheckBox } from './input/A2UICheckBox.tsx';
import { A2UIChoicePicker } from './input/A2UIChoicePicker.tsx';
import { A2UIDateTimeInput } from './input/A2UIDateTimeInput.tsx';
import { A2UISlider } from './input/A2UISlider.tsx';
import { A2UITextField } from './input/A2UITextField.tsx';
import { A2UICard } from './layout/A2UICard.tsx';
import { A2UIColumn } from './layout/A2UIColumn.tsx';
import { A2UIDivider } from './layout/A2UIDivider.tsx';
import { A2UIList } from './layout/A2UIList.tsx';
import { A2UIRow } from './layout/A2UIRow.tsx';

const allComponents = {
	Text: A2UIText,
	Image: A2UIImage,
	Icon: A2UIIcon,
	Video: A2UIVideo,
	AudioPlayer: A2UIAudioPlayer,
	Row: A2UIRow,
	Column: A2UIColumn,
	List: A2UIList,
	Card: A2UICard,
	Divider: A2UIDivider,
	Button: A2UIButton,
	TextField: A2UITextField,
	CheckBox: A2UICheckBox,
	ChoicePicker: A2UIChoicePicker,
	Slider: A2UISlider,
	DateTimeInput: A2UIDateTimeInput,
	Tabs: A2UITabs,
	Modal: A2UIModal,
};

let registered = false;

export const ensureComponentsRegistered = (): void => {
	if (!registered) {
		registerAllComponents(allComponents);
		registered = true;
	}
};
